export function parseCurrencyValue(val) {
  const parsed = parseFloat(String(val).replace(/\s/g, ''));
  return Number.isNaN(parsed) ? 0 : parsed;
}

export function formatCurrency(val, digits = 2) {
  if (val !== null) {
    let x = parseCurrencyValue(val);
    if (Number.isNaN(x)) {
      return '';
    }
    const decimalLimiter = 10 ** digits;
    x = Math.round((x + Number.EPSILON) * decimalLimiter) / decimalLimiter;
    const parts = x.toFixed(digits).split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
    return parts.join('.');
  }
}
